import { Component, OnDestroy } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { Language } from '@meplis/common';
import { Location } from '@angular/common';
import { CommonUrlBasedService } from '@meplis/services';
import { TranslateService } from '@ngx-translate/core';
import { HeaderComponent } from './shared/components/common/header/header.component';
import { AuthenticationService } from './shared/services/application/authentication.service';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { Subscription } from 'rxjs';

@Component({
  imports: [RouterModule, HeaderComponent],
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnDestroy{
  public hideHeader: boolean;

  public blockedHeaderPages = ['login', 'recovery-password', 'sign-up'];
  public isLogged: boolean;

  public routerSubscription: Subscription;
  public authServiceSubscription: Subscription;

  constructor(
    private _translateService: TranslateService,
    private _router: Router,
    private _location: Location,
    public commonService: CommonUrlBasedService,
    public _authService: AuthenticationService,
    public _iconLibrary: FaIconLibrary
  ) {
    this._setDefaultLanguages();

    this._iconLibrary.addIconPacks(fas, far, fab);

    this.routerSubscription = this._router.events.subscribe(async (item) => {
      const route = this._location.path();
      this._handleRoute(route);
    });

    this.isLogged = this._authService.isLogged;
    this.authServiceSubscription = this._authService.getLoggedInObservable().subscribe(() => {
      this.isLogged = this._authService.isLogged;
    });
  }
  ngOnDestroy(): void {
    this.routerSubscription?.unsubscribe();
    this.authServiceSubscription?.unsubscribe();
  }

  private _handleRoute(route: string): void {
    this.hideHeader = this._filterBlockedHeaderPages(route);
  }

  private _filterBlockedHeaderPages(slug: string): boolean {
    return this.blockedHeaderPages.some((link) => slug.indexOf(link) > -1);
  }

  private _setDefaultLanguages(): void {
    const currentLanguages = Object.values(Language);
    this._translateService.addLangs(currentLanguages);
    this._translateService.setDefaultLang('en');

    const browserLang = this._translateService.getBrowserLang();

    if (browserLang) {
      const currentLanguageRegex = new RegExp(currentLanguages.join('|'), 'g');

      this._translateService.use(
        browserLang.match(currentLanguageRegex) ? browserLang : 'en'
      );
    } else {
      this._translateService.use('en');
    }
  }

  private _setLanguage(language: Language): void {
    this._translateService.use(language);
  }
}
